import { DOCUMENT_COMPONENT_TYPES } from "../constants/document";

import blockEspace from "../assets/block-ESpace.png";
import blockGSheet from "../assets/block-GSheet.png";
import blockImage from "../assets/block-image.png";
import blockPBreak from "../assets/block-PBreak.png";
import blockQTable from "../assets/block-QTable.png";
import blockSign from "../assets/block-Sign.png";
import blockStripe from "../assets/block-Stripe.png";
import blockTable from "../assets/block-table.png";
import blockText from "../assets/block-text.png";

const getDragImage = type => {
  switch (type) {
    case DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET:
      return blockGSheet;
    case DOCUMENT_COMPONENT_TYPES.IMAGE:
      return blockImage;
    case DOCUMENT_COMPONENT_TYPES.PAGE_BREAK:
      return blockPBreak;
    case DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE:
    case DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER:
      return blockQTable;
    case DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER:
      return blockSign;
    case DOCUMENT_COMPONENT_TYPES.STRIPE_PAYMENT_BUTTON:
      return blockStripe;
    case DOCUMENT_COMPONENT_TYPES.TABLE:
      return blockTable;
    case DOCUMENT_COMPONENT_TYPES.HTML:
      return blockText;
    case DOCUMENT_COMPONENT_TYPES.EMPTY_CONTAINER:
    case DOCUMENT_COMPONENT_TYPES.LINE_SPACE:
      return blockEspace;
    default:
      return null;
  }
};
export default getDragImage;



// WEBPACK FOOTER //
// ./src/utils/dragUtils.js